import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityMetrics = ({ metrics }) => {
  const metricCards = [
    {
      label: 'Total Logins',
      value: metrics?.totalLogins || 0,
      icon: 'LogIn',
      color: 'blue',
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-600'
    },
    {
      label: 'Active Sessions',
      value: metrics?.activeSessions || 0,
      icon: 'Users',
      color: 'green',
      bgColor: 'bg-green-100',
      textColor: 'text-green-600'
    },
    {
      label: 'Failed Attempts',
      value: metrics?.failedAttempts || 0,
      icon: 'XCircle',
      color: 'red',
      bgColor: 'bg-red-100',
      textColor: 'text-red-600'
    },
    {
      label: 'Success Rate',
      value: `${metrics?.successRate || 100}%`,
      icon: 'CheckCircle',
      color: 'purple',
      bgColor: 'bg-purple-100',
      textColor: 'text-purple-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {metricCards?.map((metric, index) => (
        <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <div className={`w-12 h-12 ${metric?.bgColor} rounded-lg flex items-center justify-center`}>
              <Icon name={metric?.icon} className={`w-6 h-6 ${metric?.textColor}`} />
            </div>
          </div>
          <p className="text-2xl font-bold text-gray-900 mb-1">{metric?.value}</p>
          <p className="text-sm text-gray-600">{metric?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default SecurityMetrics;